import React, { Component } from 'react';
// import { withStyles } from '@mui/material/styles';
import Close from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton, Slide, Typography } from '@mui/material';

import AppBindStyles from "../../AppBindStyles";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class EmailDialog extends Component {

    handleClose = (event) => {
      this.props.onClose(event);
    };
    
    render() {
        
        return (
          <Dialog 
                fullScreen
                maxWidth={false}
                open={this.props.open}
                onClose={this.props.onClose}
                TransitionComponent={Transition} >
            <Typography>
              <IconButton size="small"
                  style={{float:'right', margin: '32px'}} onClick={this.handleClose}
                ><Close/></IconButton>
            </Typography>
            <DialogContent style={{textAlign:'center'}}>
              <div style={{width: '100%'}}>
                <div style={{width:'90%',margin: 'auto'}}>
                  <DialogTitle style={AppBindStyles.fullScreenDialogTitle}>{this.props.title}</DialogTitle>
                  {this.props.children}
                </div>
              </div>
            </DialogContent>
          </Dialog>
        );
    }
}
  
export default EmailDialog;